/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (µL)`)
};

const es_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (µL)`)
};

const de_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt (µL)`)
};

const nl_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal (µL)`)
};

const fr_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (µL)`)
};

const it_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale (µL)`)
};

const pt_br2_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (µL)`)
};

const pt_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (µL)`)
};

const ja_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計(µL)`)
};

const zh_pcr_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总量（µL）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_total = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_total(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_total", locale)
	if (locale === "en") return en_pcr_total(inputs)
	if (locale === "es") return es_pcr_total(inputs)
	if (locale === "de") return de_pcr_total(inputs)
	if (locale === "nl") return nl_pcr_total(inputs)
	if (locale === "fr") return fr_pcr_total(inputs)
	if (locale === "it") return it_pcr_total(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_total(inputs)
	if (locale === "pt") return pt_pcr_total(inputs)
	if (locale === "ja") return ja_pcr_total(inputs)
	return zh_pcr_total(inputs)
};